import WidgetReviewsGalleryPc from '@/views/widget/WidgetReviewsGallery/WidgetReviewsGalleryPc';
import WidgetReviewsGalleryMobile from '@/views/widget/WidgetReviewsGallery/WidgetReviewsGalleryMobile';
import WidgetReviewsBestGalleryPc from '@/views/widget/WidgetReviewsBestGallery/WidgetReviewsBestGalleryPc';
import WidgetReviewsBestGalleryMobile from '@/views/widget/WidgetReviewsBestGallery/WidgetReviewsBestGalleryMobile';
import WidgetReviewsSquareGalleryPc from '@/views/widget/WidgetReviewsSquareGallery/WidgetReviewsSquareGalleryPc';
import WidgetReviewsSquareGalleryMobile from '@/views/widget/WidgetReviewsSquareGallery/WidgetReviewsSquareGalleryMobile';
import WidgetReviewsBoardMobile from '@/views/widget/WidgetReviewsBoardMobile';
import WidgetReviewsExternalPc from '@/views/widget/WidgetReviewsExternal/WidgetReviewsExternalPc';
import WidgetReviewsExternalMobile from '@/views/widget/WidgetReviewsExternal/WidgetReviewsExternalMobile';
import WidgetReviewsHorizontalScrollPc from '@/views/widget/WidgetReviewsHorizontalScroll/WidgetReviewsHorizontalScrollPc';
import WidgetReviewsHorizontalScrollMobile from '@/views/widget/WidgetReviewsHorizontalScroll/WidgetReviewsHorizontalScrollMobile';
import WidgetReviewsListV3Mobile from '@/views/widget/WidgetReviewsListV3/WidgetReviewsListV3Mobile';
import WidgetReviewsListV3Pc from '@/views/widget/WidgetReviewsListV3/WidgetReviewsListV3Pc';
import WidgetProductReviewsListV3Mobile from '@/views/widget/WidgetProductReviewsListV3/WidgetProductReviewsListV3Mobile';
import WidgetProductReviewsListV3Pc from '@/views/widget/WidgetProductReviewsListV3/WidgetProductReviewsListV3Pc';
import WidgetProductReviewsGalleryPc from '@/views/widget/WidgetProductReviewsGallery/WidgetProductReviewsGalleryPc';
import WidgetProductReviewsGalleryMobile from '@/views/widget/WidgetProductReviewsGallery/WidgetProductReviewsGalleryMobile';
import WidgetProductReviewsBoardPc from '@/views/widget/WidgetProductReviewsBoard/WidgetProductReviewsBoardPc';
import WidgetProductReviewsBoardMobile from '@/views/widget/WidgetProductReviewsBoard/WidgetProductReviewsBoardMobile';
import WidgetProductReviewsExternalPc from '@/views/widget/WidgetProductReviewsExternal/WidgetProductReviewsExternalPc';
import WidgetProductReviewsExternalMobile from '@/views/widget/WidgetProductReviewsExternal/WidgetProductReviewsExternalMobile';
import WidgetProductReviewsHorizontalScrollPc from '@/views/widget/WidgetProductReviewsHorizontalScroll/WidgetProductReviewsHorizontalScrollPc';
import WidgetProductReviewsHorizontalScrollMobile from '@/views/widget/WidgetProductReviewsHorizontalScroll/WidgetProductReviewsHorizontalScrollMobile';
import WidgetProductReviewsProductOptionsPc from '@/views/widget/WidgetProductReviewsProductOptions/WidgetProductReviewsProductOptionsPc';
import WidgetProductReviewsProductOptionsMobile from '@/views/widget/WidgetProductReviewsProductOptions/WidgetProductReviewsProductOptionsMobile';
import WidgetProductReviewsStatisticsPc from '@/views/widget/WidgetProductReviewsStatistics/WidgetProductReviewsStatisticsPc';
import WidgetProductReviewsStatisticsMobile from '@/views/widget/WidgetProductReviewsStatistics/WidgetProductReviewsStatisticsMobile';
import WidgetProductReviewsPhotoThumbnailMobile from '@/views/widget/WidgetProductReviewsPhotoThumbnail/WidgetProductReviewsPhotoThumbnailMobile';
import WidgetProductReviewsPhotoThumbnailPc from '@/views/widget/WidgetProductReviewsPhotoThumbnail/WidgetProductReviewsPhotoThumbnailPc';

import WidgetCategoryReviewsGalleryPc from '@/views/widget/WidgetCategoryReviewsGallery/WidgetCategoryReviewsGalleryPc';
import WidgetCategoryReviewsGalleryMobile from '@/views/widget/WidgetCategoryReviewsGallery/WidgetCategoryReviewsGalleryMobile';
import WidgetCategoryReviewsBoardMobile from '@/views/widget/WidgetCategoryReviewsBoardMobile';
import WidgetCategoryReviewsListPc from '@/views/widget/WidgetCategoryReviewsList/WidgetCategoryReviewsListPc';
import WidgetCategoryReviewsListMobile from '@/views/widget/WidgetCategoryReviewsList/WidgetCategoryReviewsListMobile';
import WidgetCategoryReviewsHorizontalScrollPc from '@/views/widget/WidgetCategoryReviewsHorizontalScroll/WidgetCategoryReviewsHorizontalScrollPc';
import WidgetCategoryReviewsHorizontalScrollMobile from '@/views/widget/WidgetCategoryReviewsHorizontalScroll/WidgetCategoryReviewsHorizontalScrollMobile';
import WidgetCategoryReviewsSquareGalleryPc from '@/views/widget/WidgetCategoryReviewsSquareGallery/WidgetCategoryReviewsSquareGalleryPc';
import WidgetCategoryReviewsSquareGalleryMobile from '@/views/widget/WidgetCategoryReviewsSquareGallery/WidgetCategoryReviewsSquareGalleryMobile';
import WidgetCategoryReviewsBestGalleryMobile from '@/views/widget/WidgetCategoryReviewsBestGallery/WidgetCategoryReviewsBestGalleryMobile';
import WidgetCategoryReviewsBestGalleryPc from '@/views/widget/WidgetCategoryReviewsBestGallery/WidgetCategoryReviewsBestGalleryPc';

import WidgetProductsProductThumbnailMobile from '@/views/widget/WidgetProductsProductThumbnail/WidgetProductsProductThumbnailMobile';
import WidgetProductsProductThumbnailPc from '@/views/widget/WidgetProductsProductThumbnail/WidgetProductsProductThumbnailPc';

import WidgetAddOnReviewsSummary from '@/views/widget/WidgetAddOnReviewsSummary/WidgetAddOnReviewsSummary';
import WidgetAddOnSizeRecommendation from '@/views/widget/WidgetAddOnSizeRecommendation/WidgetAddOnSizeRecommendation';
import WidgetAddOnSizeRecommendationPopup from '@/views/widget/WidgetAddOnSizeRecommendationPopup/WidgetAddOnSizeRecommendationPopup';

import ReviewsNew from '@/views/widget/ReviewsNew/ReviewsNew';
import ReviewsShowMobile from '@/views/widget/ReviewsShow/ReviewsShowMobile';
import ReviewsShowPc from '@/views/widget/ReviewsShow/ReviewsShowPc';
import ProductReviewsMediaCollagePc from '@/views/widget/ProductReviewsMediaCollage/ProductReviewsMediaCollagePc';
import ProductReviewsMediaCollageMobile from '@/views/widget/ProductReviewsMediaCollage/ProductReviewsMediaCollageMobile';
import ReviewsShortsPopup from '@/views/widget/ReviewsShortsPopup/ReviewsShortsPopup';
import ManagingReviews from '@/views/widget/ManagingReviews/ManagingReviews';
import ReviewPrompt from '@/views/widget/ReviewPrompt/ReviewPrompt';
import TheWidget from '@/layouts/TheWidget';

import WidgetType from '@/enums/WidgetType';

const REVIEWS_ROUTES = [
  {
    path: '/:brand_code/reviews/gallery',
    component: WidgetReviewsGalleryPc
  },
  {
    path: '/:brand_code/mobile/reviews/gallery',
    component: WidgetReviewsGalleryMobile
  },
  {
    path: '/:brand_code/reviews/best_gallery',
    component: WidgetReviewsBestGalleryPc
  },
  {
    path: '/:brand_code/mobile/reviews/best_gallery',
    component: WidgetReviewsBestGalleryMobile
  },
  {
    path: '/:brand_code/reviews/square_gallery',
    component: WidgetReviewsSquareGalleryPc
  },
  {
    path: '/:brand_code/mobile/reviews/square_gallery',
    component: WidgetReviewsSquareGalleryMobile
  },
  {
    path: '/:brand_code/reviews/main_gallery',
    component: WidgetReviewsGalleryPc
  },
  {
    path: '/:brand_code/mobile/reviews/main_gallery',
    component: WidgetReviewsGalleryMobile
  },
  {
    path: '/:brand_code/mobile/reviews/board',
    component: WidgetReviewsBoardMobile
  },
  {
    path: '/:brand_code/reviews/external',
    component: WidgetReviewsExternalPc
  },
  {
    path: '/:brand_code/mobile/reviews/external',
    component: WidgetReviewsExternalMobile
  },
  {
    path: '/:brand_code/reviews/horizontal_scroll',
    component: WidgetReviewsHorizontalScrollPc
  },
  {
    path: '/:brand_code/mobile/reviews/horizontal_scroll',
    component: WidgetReviewsHorizontalScrollMobile
  },
  {
    path: '/:brand_code/mobile/reviews/list_v3',
    component: WidgetReviewsListV3Mobile
  },
  {
    path: '/:brand_code/reviews/list_v3',
    component: WidgetReviewsListV3Pc
  }
].map(e => ({ ...e, widgetType: WidgetType.REVIEWS }));

const PRODUCT_REVIEWS_ROUTES = [
  {
    path: '/:brand_code/mobile/product_reviews/list_v3',
    component: WidgetProductReviewsListV3Mobile
  },
  {
    path: '/:brand_code/product_reviews/list_v3',
    component: WidgetProductReviewsListV3Pc
  },
  {
    path: '/:brand_code/mobile/product_reviews/gallery',
    component: WidgetProductReviewsGalleryMobile
  },
  {
    path: '/:brand_code/product_reviews/gallery',
    component: WidgetProductReviewsGalleryPc
  },
  {
    path: '/:brand_code/mobile/product_reviews/board',
    component: WidgetProductReviewsBoardMobile
  },
  {
    path: '/:brand_code/product_reviews/board',
    component: WidgetProductReviewsBoardPc
  },
  {
    path: '/:brand_code/product_reviews/external',
    component: WidgetProductReviewsExternalPc
  },
  {
    path: '/:brand_code/mobile/product_reviews/external',
    component: WidgetProductReviewsExternalMobile
  },
  {
    path: '/:brand_code/product_reviews/horizontal_scroll',
    component: WidgetProductReviewsHorizontalScrollPc
  },
  {
    path: '/:brand_code/mobile/product_reviews/horizontal_scroll',
    component: WidgetProductReviewsHorizontalScrollMobile
  },
  {
    path: '/:brand_code/product_reviews/product_options',
    component: WidgetProductReviewsProductOptionsPc
  },
  {
    path: '/:brand_code/mobile/product_reviews/product_options',
    component: WidgetProductReviewsProductOptionsMobile
  },
  {
    path: '/:brand_code/product_reviews/statistics',
    component: WidgetProductReviewsStatisticsPc
  },
  {
    path: '/:brand_code/mobile/product_reviews/statistics',
    component: WidgetProductReviewsStatisticsMobile
  },
  {
    path: '/:brand_code/product_reviews/photo_thumbnail',
    component: WidgetProductReviewsPhotoThumbnailPc
  },
  {
    path: '/:brand_code/mobile/product_reviews/photo_thumbnail',
    component: WidgetProductReviewsPhotoThumbnailMobile
  },
  {
    path: '/:brand_code/mobile/product_reviews/detachable_board',
    component: WidgetProductReviewsBoardMobile
  }
].map(e => ({ ...e, widgetType: WidgetType.PRODUCT_REVIEWS }));

const CATEGORY_REVIEWS_ROUTES = [
  {
    path: '/:brand_code/category_reviews/gallery',
    component: WidgetCategoryReviewsGalleryPc
  },
  {
    path: '/:brand_code/mobile/category_reviews/gallery',
    component: WidgetCategoryReviewsGalleryMobile
  },
  {
    path: '/:brand_code/mobile/category_reviews/board',
    component: WidgetCategoryReviewsBoardMobile
  },
  {
    path: '/:brand_code/category_reviews/list',
    component: WidgetCategoryReviewsListPc
  },
  {
    path: '/:brand_code/mobile/category_reviews/list',
    component: WidgetCategoryReviewsListMobile
  },
  {
    path: '/:brand_code/category_reviews/horizontal_scroll',
    component: WidgetCategoryReviewsHorizontalScrollPc
  },
  {
    path: '/:brand_code/mobile/category_reviews/horizontal_scroll',
    component: WidgetCategoryReviewsHorizontalScrollMobile
  },
  {
    path: '/:brand_code/category_reviews/square_gallery',
    component: WidgetCategoryReviewsSquareGalleryPc
  },
  {
    path: '/:brand_code/mobile/category_reviews/square_gallery',
    component: WidgetCategoryReviewsSquareGalleryMobile
  },
  {
    path: '/:brand_code/category_reviews/best_gallery',
    component: WidgetCategoryReviewsBestGalleryPc
  },
  {
    path: '/:brand_code/mobile/category_reviews/best_gallery',
    component: WidgetCategoryReviewsBestGalleryMobile
  }
].map(e => ({ ...e, widgetType: WidgetType.CATEGORY_REVIEWS }));

const PRODUCTS_ROUTES = [
  {
    path: '/:brand_code/mobile/products/product_thumbnail',
    component: WidgetProductsProductThumbnailMobile
  },
  {
    path: '/:brand_code/products/product_thumbnail',
    component: WidgetProductsProductThumbnailPc
  }
].map(e => ({ ...e, widgetType: WidgetType.PRODUCTS }));

const ADD_ON_ROUTES = [
  {
    path: '/:brand_code/add_on/reviews_summary',
    component: WidgetAddOnReviewsSummary
  },
  {
    path: '/:brand_code/add_on/size_recommendation',
    component: WidgetAddOnSizeRecommendation
  },
  {
    path: '/:brand_code/add_on/size_recommendation/popup',
    component: WidgetAddOnSizeRecommendationPopup
  }
].map(e => ({ ...e, widgetType: WidgetType.ADD_ON }));

const MISC_ROUTES = [
  {
    path: '/:brand_code/reviews/new',
    component: ReviewsNew,
    widgetType: WidgetType.REVIEWS_NEW
  },
  {
    path: '/:brand_code/reviews/:review_id/edit',
    component: ReviewsNew,
    widgetType: WidgetType.REVIEWS_NEW
  },
  {
    path: '/:brand_code/review/prompt',
    component: ReviewPrompt,
    widgetType: WidgetType.REVIEW_PROMPT
  },
  {
    path: '/:brand_code/reviews/:review_id/shorts',
    component: ReviewsShortsPopup,
    widgetType: WidgetType.REVIEWS_SHORTS_POPUP
  },
  {
    path: '/:brand_code/mobile/reviews/:review_id(\\d+)',
    component: ReviewsShowMobile,
    widgetType: WidgetType.REVIEWS_SHOW
  },
  {
    path: '/:brand_code/reviews/:review_id(\\d+)',
    component: ReviewsShowPc,
    widgetType: WidgetType.REVIEWS_SHOW
  },
  {
    path: '/:brand_code/product_reviews/media_collage',
    component: ProductReviewsMediaCollagePc,
    widgetType: WidgetType.PRODUCT_REVIEWS_MEDIA_COLLAGE_POPUP
  },
  {
    path: '/:brand_code/mobile/product_reviews/media_collage',
    component: ProductReviewsMediaCollageMobile,
    widgetType: WidgetType.PRODUCT_REVIEWS_MEDIA_COLLAGE_POPUP
  },
  {
    path: '/:brand_code/managing_reviews/managing_reviews',
    component: ManagingReviews,
    widgetType: WidgetType.MANAGING_REVIEWS
  }
];

export default [
  ...REVIEWS_ROUTES,
  ...PRODUCT_REVIEWS_ROUTES,
  ...CATEGORY_REVIEWS_ROUTES,
  ...PRODUCTS_ROUTES,
  ...ADD_ON_ROUTES,
  ...MISC_ROUTES
].map(item => {
  return {
    path: item.path,
    component: TheWidget,
    props: { widgetType: item.widgetType },
    children: [
      {
        path: '',
        component: item.component
      }
    ]
  };
});
